import { useTranslation } from 'react-i18next';
import PageShell from '@/components/feature/PageShell';

export default function ReviewPage() {
  const { t } = useTranslation('pages');

  const pros = ['review_pro_1', 'review_pro_2', 'review_pro_3', 'review_pro_4'];
  const cons = ['review_con_1', 'review_con_2', 'review_con_3'];

  return (
    <PageShell
      eyebrow={t('review_eyebrow')}
      title={t('review_h1')}
      intro={t('review_intro')}
    >
      <div className="space-y-10">
        <section>
          <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-4">
            {t('review_s1_title')}
          </h2>
          <p className="text-foreground-600 text-base leading-relaxed">{t('review_s1_body')}</p>
        </section>
        <section>
          <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-4">
            {t('review_s2_title')}
          </h2>
          <p className="text-foreground-600 text-base leading-relaxed">{t('review_s2_body')}</p>
        </section>
        <section>
          <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-4">
            {t('review_s3_title')}
          </h2>
          <p className="text-foreground-600 text-base leading-relaxed mb-6">{t('review_s3_body')}</p>

          <div className="grid sm:grid-cols-2 gap-4">
            <div className="bg-background-100 rounded-xl p-5 border border-background-200/40">
              <h3 className="font-heading text-base font-semibold text-primary-700 mb-3 flex items-center gap-2">
                <i className="ri-thumb-up-line"></i>
                {t('review_pros_title')}
              </h3>
              <ul className="space-y-2">
                {pros.map((p) => (
                  <li key={p} className="flex items-start gap-2 text-sm text-foreground-600">
                    <i className="ri-check-line text-primary-500 mt-0.5"></i>
                    {t(p)}
                  </li>
                ))}
              </ul>
            </div>
            <div className="bg-background-100 rounded-xl p-5 border border-background-200/40">
              <h3 className="font-heading text-base font-semibold text-accent-700 mb-3 flex items-center gap-2">
                <i className="ri-error-warning-line"></i>
                {t('review_cons_title')}
              </h3>
              <ul className="space-y-2">
                {cons.map((c) => (
                  <li key={c} className="flex items-start gap-2 text-sm text-foreground-600">
                    <i className="ri-close-line text-accent-500 mt-0.5"></i>
                    {t(c)}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>
      </div>
    </PageShell>
  );
}